/* Shipments */
import { Route } from "vue-router";
import { VersionCheckService } from "@/services/VersionCheckService";
import Shipments from "./Shipments.vue";
import ShipmentsMenuNew from "./ShipmentsMenuNew.vue";
import EditShipment from "./EditShipment/EditShipment.vue";
import ExportShipments from "./ExportShipments.vue";
import NewShipment from "./EditShipment/NewShipment.vue";
import ShipmentsManagement from "./ShipmentsManagement/ShipmentsManagement.vue";
import NewImport from "./Import/NewImport.vue";
import PickupsList from "./Pickups/PickupsList.vue";
import PickupDetails from "./Pickups/PickupDetails.vue";
import ClosuresList from "./ClosuresManagement/ClosuresList.vue";
import ShipmentCostCalculate from "./ShipmentCostCalculate/ShipmentCostCalculate.vue";
import PaperlessManagement from "@/components/shipments/PaperlessManagement.vue";
import CourierPickupsManagement from "./CourierPickupsManagement.vue";
import WineShipmentsManagement from "@/components/shipments/ShipmentsManagement/WineShipmentsManagement.vue";
import ClaimManagement from "./ClaimManagement.vue";
import IncidentDetails from "./IncidentDetails.vue";

export default {
  path: "/shipments",
  name: "Shipments",
  component: Shipments,
  meta: {
    breadcrumb: "shipments"
  },
  children: [
    {
      path: "",
      name: "ShipmentsMenuNew",
      component: ShipmentsMenuNew,
      beforeEnter: (to: Route, from: Route, next: any) => {
        return VersionCheckService.prototype.versionGuard(to, from, next);
      }
    },
    {
      path: "new-shipment",
      name: "NewShipment",
      component: NewShipment,
      meta: {
        breadcrumb: "shipments"
      },
      beforeEnter: (to: Route, from: Route, next: any) => {
        return VersionCheckService.prototype.versionGuard(to, from, next);
      }
    },
    {
      path: "edit-shipment/:id",
      name: "EditShipment",
      component: EditShipment,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "shipments-management",
      name: "ShipmentsManagement",
      component: ShipmentsManagement,
      meta: {
        breadcrumb: "shipments"
      },
      beforeEnter: (to: Route, from: Route, next: any) => {
        return VersionCheckService.prototype.versionGuard(to, from, next);
      }
    },
    {
      path: "wine-shipments-management",
      name: "WineShipmentsManagement",
      component: WineShipmentsManagement,
      meta: {
        breadcrumb: "shipments"
      },
      beforeEnter: (to: Route, from: Route, next: any) => {
        return VersionCheckService.prototype.versionGuard(to, from, next);
      }
    },
    {
      path: "new-import",
      name: "NewImport",
      component: NewImport,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "mbe_centre_pickups",
      name: "PickupsList",
      component: PickupsList,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "mbe_centre_pickups/:id",
      name: "PickupDetails",
      component: PickupDetails,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "closures",
      name: "ClosuresList",
      component: ClosuresList,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "cost-calculate",
      name: "ShipmentCostCalculate",
      component: ShipmentCostCalculate
    },
    {
      path: "export-templates",
      name: "ExportShipments",
      component: ExportShipments,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "paperless-management",
      name: "PaperlessManagement",
      component: PaperlessManagement,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "courier-pickups-management",
      name: "CourierPickupsManagement",
      component: CourierPickupsManagement,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "claim-management",
      name: "ClaimManagement",
      component: ClaimManagement,
      meta: {
        breadcrumb: "shipments"
      }
    },
    {
      path: "incident-details/:id",
      name: "IncidentDetails",
      component: IncidentDetails,
      meta: {
        breadcrumb: "shipments"
      }
    }
  ]
};
